import React from "react";

const FilledStar = ({ size = 20, ...rest }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="star-04">
                <path
                    id="Icon"
                    d="M10 1.66675L11.6767 6.02599C11.9117 6.63701 12.0292 6.94252 12.2119 7.19951C12.3738 7.42727 12.5728 7.62626 12.8006 7.78821C13.0576 7.97094 13.3631 8.08844 13.9741 8.32345L18.3334 10.0001L13.9741 11.6767C13.3631 11.9117 13.0576 12.0292 12.8006 12.212C12.5728 12.3739 12.3738 12.5729 12.2119 12.8007C12.0292 13.0576 11.9117 13.3632 11.6767 13.9742L10 18.3334L8.32339 13.9742C8.08838 13.3632 7.97088 13.0576 7.78815 12.8007C7.6262 12.5729 7.4272 12.3739 7.19944 12.212C6.94246 12.0292 6.63695 11.9117 6.02593 11.6767L1.66669 10.0001L6.02592 8.32345C6.63695 8.08844 6.94246 7.97094 7.19944 7.78821C7.4272 7.62626 7.6262 7.42727 7.78815 7.1995C7.97088 6.94252 8.08838 6.63701 8.32339 6.02599L10 1.66675Z"
                    fill="#9195A9"
                />
            </g>
        </svg>
    );
};

export default FilledStar;
